import React, { useContext, useState } from 'react';
import { IPaginationParams } from '../../../../services/types';

import { AppContext } from '../../../../context/AppContextProvider';
import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import ButtonActionsComponent from '../../../../components/ButtonActionsComponent';
import ButtonComponent from '../../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';
import ConfirmDeleteModalComponent from '../../../../components/ConfirmDeleteModalComponent';
import {
  IWhatsAppNumbersFilterProps,
  IWhatsAppNumbersProps,
  IWhatsAppNumbersSimpleProps,
} from '../../../../services/WhatsAppNumberService/types';
import {
  useGetAllWhatsAppNumbersByLicense,
  useGetAllWhatsAppNumbersByLicenseCount,
} from '../../../../services/WhatsAppNumberService/hooks/useQuery';
import {
  useDeleteWhatsAppNumber,
  useGetWhatsAppNumber,
} from '../../../../services/WhatsAppNumberService/hooks/useMutation';
import WhatsAppNumberEditionModal from './WhatsAppNumberEditionModal';

const WhatsAppNumbersManagementTab = () => {
  const [isVisibleDeletionModal, setIsVisibleDeletionModal] =
    useState<boolean>(false);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [filter, setFilter] = useState<IWhatsAppNumbersFilterProps>({
    name: '',
    phoneNumber: '',
  });
  const [selectedItem, setSelectedItem] =
    useState<IWhatsAppNumbersSimpleProps>();
  const {
    data: telegramIds,
    refetch: refetchTelegramIds,
    isLoading: isLoadingTelegramIds,
  } = useGetAllWhatsAppNumbersByLicense(pagination, filter);
  const {
    data: telegramIdsCounts,
    refetch: refetchCount,
    isLoading: isLoadingCount,
  } = useGetAllWhatsAppNumbersByLicenseCount(pagination, filter);
  const { mutateAsync: mutateDeleteWhatsAppNumber } = useDeleteWhatsAppNumber();
  const { mutateAsync: mutateGetWhatsAppNumber } = useGetWhatsAppNumber();
  const { showSnackbar } = useContext(AppContext);
  const columns: IColumnProps[] = [
    {
      id: 'name',
      label: 'Nome',
    },
    {
      id: 'phoneNumber',
      label: 'Número de Celular',
    },
    {
      id: 'id',
      align: 'center',
      width: '0px',
      label: 'Ações',
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const handleConfirmDeletion = async () => {
    if (selectedItem?.id)
      mutateDeleteWhatsAppNumber(selectedItem?.id).then(() => {
        showSnackbar('Contato do WhatsApp excluído com sucesso.', 'success');
        setSelectedItem(undefined);
        setIsVisibleDeletionModal(false);
        refetchAll();
      });
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeletionModal(false);
    setSelectedItem(undefined);
  };

  const handleDeleteItem = (id: number) => {
    if (telegramIds) {
      setSelectedItem(telegramIds.find((t) => t.id === id));
      setIsVisibleDeletionModal(true);
    }
  };

  const handleEdit = (id: number) => {
    mutateGetWhatsAppNumber(id).then((data: IWhatsAppNumbersProps) => {
      setSelectedItem(data);
      setIsVisibleEditionModal(true);
    });
  };

  const handleSaveForm = () => {
    setSelectedItem(undefined);
    refetchAll();
  };

  const refetchAll = async () => {
    await refetchTelegramIds();
    await refetchCount();
  };

  return (
    <>
      <TableComponent
        rows={telegramIds ?? []}
        columns={columns}
        isLoading={isLoadingTelegramIds || isLoadingCount}
        onChangePageOrRowsPerPage={setPagination}
        totalCount={telegramIdsCounts}
        title={'Contatos WhatsApp'}
        additionalTitleComponent={
          <ButtonComponent
            onClick={() => setIsVisibleEditionModal(true)}
            startIcon={<Add />}
          >
            Novo Contato
          </ButtonComponent>
        }
        onChangeMainFilter={(val) =>
          setFilter((oldSt) => ({ ...oldSt, name: val }))
        }
        onSubmitMainFilter={refetchAll}
      />
      <ConfirmDeleteModalComponent
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
        isVisibleDeleteDialog={isVisibleDeletionModal}
        message={`Deseja deletar o contato ${selectedItem?.name} (${selectedItem?.phoneNumber}) ?`}
        setIsVisibleDeleteDialog={setIsVisibleDeletionModal}
        title={'Deletar Contato do WhatsApp'}
      />
      <WhatsAppNumberEditionModal
        selectedItem={selectedItem}
        isOpen={isVisibleEditionModal}
        setIsOpen={setIsVisibleEditionModal}
        handleForm={handleSaveForm}
      />
    </>
  );
};

export default WhatsAppNumbersManagementTab;
